import { Integrations } from "@sentry/tracing";
export { init, setTag, setUser } from "@sentry/react";
export const getIntegrations = () => [
    new Integrations.BrowserTracing({
        tracePropagationTargets: [/nexthealth/, /t-doc/],
    }),
];
